var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-layout-header",
    { class: [_vm.headerTheme, "admin-header", _vm.noshadown] },
    [
      _c(
        "div",
        {
          class: ["admin-header-wide", _vm.layout, _vm.pageWidth],
          staticStyle: { display: "flex" },
        },
        [
          _vm.isMobile || _vm.layout === "head"
            ? _c(
                "router-link",
                {
                  class: ["logo", _vm.isMobile ? null : "pc", _vm.headerTheme],
                  attrs: { to: "/" },
                },
                [
                  _c("svg-icon", {
                    staticClass: "logosvg",
                    attrs: { iconClass: "logo" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "admin-header-left-wrapper" }, [
            _vm.quotaWarningList.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "quota-warning-scroll",
                    on: {
                      mouseenter: _vm.handleMouseEnter,
                      mouseleave: _vm.handleMouseLeave,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "quota-warning-list",
                        class: { "no-transition": !_vm.isTransitioning },
                        style: {
                          transform: `translateY(-${_vm.translateY}px)`,
                        },
                        on: { transitionend: _vm.handleTransitionEnd },
                      },
                      [
                        _vm.quotaWarningList.length > 1
                          ? _c(
                              "div",
                              {
                                key: "clone-last",
                                staticClass: "quota-warning-item",
                              },
                              [
                                _c("span", { staticClass: "quota-label" }, [
                                  _vm._v(_vm._s(_vm.$t("QuotaWarning")) + ":"),
                                ]),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("LinkedinAccout")) +
                                      ": " +
                                      _vm._s(
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].linkedin_email
                                      )
                                  ),
                                ]),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v("|"),
                                ]),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.quotaWarningList[
                                        _vm.quotaWarningList.length - 1
                                      ].version_name
                                    )
                                  ),
                                ]),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v("|"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "quota-label-red": _vm.isRed(
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement
                                          .connection_request_balance,
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.max_connection_request
                                      ),
                                      "quota-text": !_vm.isRed(
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement
                                          .connection_request_balance,
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.max_connection_request
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("ConnectionRequestQuota")) +
                                        "： "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.quotaWarningList[0].entitlement
                                              .connection_request_balance
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v("|"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "quota-label-red": _vm.isRed(
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.connection_balance,
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.max_connection
                                      ),
                                      "quota-text": !_vm.isRed(
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.connection_balance,
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.max_connection
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("ConnectionMadeQuota")) +
                                        ": "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.quotaWarningList[
                                              _vm.quotaWarningList.length - 1
                                            ].entitlement.connection_balance
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v("|"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "quota-label-red": _vm.isRed(
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.message_balance,
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.max_message
                                      ),
                                      "quota-text": !_vm.isRed(
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.message_balance,
                                        _vm.quotaWarningList[
                                          _vm.quotaWarningList.length - 1
                                        ].entitlement.max_message
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("MessageQuota")) + ": "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.quotaWarningList[
                                              _vm.quotaWarningList.length - 1
                                            ].entitlement.message_balance
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                                ((_vm.quotaWarningList[
                                  _vm.quotaWarningList.length - 1
                                ].entitlement.connection_request_balance,
                                _vm.quotaWarningList[
                                  _vm.quotaWarningList.length - 1
                                ].entitlement.max_connection_request) ||
                                  _vm.isRed(
                                    _vm.quotaWarningList[
                                      _vm.quotaWarningList.length - 1
                                    ].entitlement.message_balance,
                                    _vm.quotaWarningList[
                                      _vm.quotaWarningList.length - 1
                                    ].entitlement.max_message
                                  ) ||
                                  _vm.isRed(
                                    _vm.quotaWarningList[
                                      _vm.quotaWarningList.length - 1
                                    ].entitlement.connection_balance,
                                    _vm.quotaWarningList[
                                      _vm.quotaWarningList.length - 1
                                    ].entitlement.max_connection
                                  )) &&
                                _vm.quotaWarningList[
                                  _vm.quotaWarningList.length - 1
                                ].version_name != "Prime Plan"
                                  ? [
                                      _c(
                                        "span",
                                        { staticClass: "quota-text" },
                                        [_vm._v("|")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "quota-text" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Upgradeplan")) + ":"
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        " // eslint-disable-next-line no-irregular-whitespace, no-irregular-whitespace "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "quota-link",
                                          attrs: {
                                            href: "mailto:" + _vm.mailInfo,
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.mailInfo))]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._l(_vm.quotaWarningList, function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "quota-warning-item" },
                            [
                              _c("span", { staticClass: "quota-label" }, [
                                _vm._v(_vm._s(_vm.$t("QuotaWarning")) + ":"),
                              ]),
                              _c("span", { staticClass: "quota-text" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("LinkedinAccout")) +
                                    ": " +
                                    _vm._s(item.linkedin_email)
                                ),
                              ]),
                              _c("span", { staticClass: "quota-text" }, [
                                _vm._v("|"),
                              ]),
                              _c("span", { staticClass: "quota-text" }, [
                                _vm._v(_vm._s(item.version_name)),
                              ]),
                              _c("span", { staticClass: "quota-text" }, [
                                _vm._v("|"),
                              ]),
                              _c(
                                "span",
                                {
                                  class: {
                                    "quota-label-red": _vm.isRed(
                                      item.entitlement
                                        .connection_request_balance,
                                      item.entitlement.max_connection_request
                                    ),
                                    "quota-text": !_vm.isRed(
                                      item.entitlement
                                        .connection_request_balance,
                                      item.entitlement.max_connection_request
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ConnectionRequestQuota")) +
                                      "： "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.entitlement
                                            .connection_request_balance
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c("span", { staticClass: "quota-text" }, [
                                _vm._v("|"),
                              ]),
                              _c(
                                "span",
                                {
                                  class: {
                                    "quota-label-red": _vm.isRed(
                                      item.entitlement.connection_balance,
                                      item.entitlement.max_connection
                                    ),
                                    "quota-text": !_vm.isRed(
                                      item.entitlement.connection_balance,
                                      item.entitlement.max_connection
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ConnectionMadeQuota")) + ": "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.entitlement.connection_balance
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              _c("span", { staticClass: "quota-text" }, [
                                _vm._v("|"),
                              ]),
                              _c(
                                "span",
                                {
                                  class: {
                                    "quota-label-red": _vm.isRed(
                                      item.entitlement.message_balance,
                                      item.entitlement.max_message
                                    ),
                                    "quota-text": !_vm.isRed(
                                      item.entitlement.message_balance,
                                      item.entitlement.max_message
                                    ),
                                  },
                                },
                                [
                                  _vm._v(_vm._s(_vm.$t("MessageQuota")) + ": "),
                                  _c("b", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.entitlement.message_balance
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              ),
                              ((item.entitlement.connection_request_balance,
                              item.entitlement.max_connection_request) ||
                                _vm.isRed(
                                  item.entitlement.message_balance,
                                  item.entitlement.max_message
                                ) ||
                                _vm.isRed(
                                  item.entitlement.connection_balance,
                                  item.entitlement.max_connection
                                )) &&
                              item.version_name != "Prime Plan"
                                ? [
                                    _c("span", { staticClass: "quota-text" }, [
                                      _vm._v("|"),
                                    ]),
                                    _c("span", { staticClass: "quota-text" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("Upgradeplan")) + ":"
                                      ),
                                    ]),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "quota-link",
                                        attrs: {
                                          href: "mailto:" + _vm.mailInfo,
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.mailInfo))]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        _vm.quotaWarningList.length > 1
                          ? _c(
                              "div",
                              {
                                key: "clone-first",
                                staticClass: "quota-warning-item",
                              },
                              [
                                _c("span", { staticClass: "quota-label" }, [
                                  _vm._v(_vm._s(_vm.$t("QuotaWarning")) + ":"),
                                ]),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("LinkedinAccout")) +
                                      ": " +
                                      _vm._s(
                                        _vm.quotaWarningList[0].linkedin_email
                                      )
                                  ),
                                ]),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v("|"),
                                ]),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v(
                                    _vm._s(_vm.quotaWarningList[0].version_name)
                                  ),
                                ]),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v("|"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "quota-label-red": _vm.isRed(
                                        _vm.quotaWarningList[0].entitlement
                                          .connection_request_balance,
                                        _vm.quotaWarningList[0].entitlement
                                          .max_connection_request
                                      ),
                                      "quota-text": !_vm.isRed(
                                        _vm.quotaWarningList[0].entitlement
                                          .connection_request_balance,
                                        _vm.quotaWarningList[0].entitlement
                                          .max_connection_request
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("ConnectionRequestQuota")) +
                                        "： "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.quotaWarningList[0].entitlement
                                              .connection_request_balance
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v("|"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "quota-label-red": _vm.isRed(
                                        _vm.quotaWarningList[0].entitlement
                                          .connection_balance,
                                        _vm.quotaWarningList[0].entitlement
                                          .max_connection
                                      ),
                                      "quota-text": !_vm.isRed(
                                        _vm.quotaWarningList[0].entitlement
                                          .connection_balance,
                                        _vm.quotaWarningList[0].entitlement
                                          .max_connection
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("ConnectionMadeQuota")) +
                                        ": "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.quotaWarningList[0].entitlement
                                              .connection_balance
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("span", { staticClass: "quota-text" }, [
                                  _vm._v("|"),
                                ]),
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "quota-label-red": _vm.isRed(
                                        _vm.quotaWarningList[0].entitlement
                                          .message_balance,
                                        _vm.quotaWarningList[0].entitlement
                                          .max_message
                                      ),
                                      "quota-text": !_vm.isRed(
                                        _vm.quotaWarningList[0].entitlement
                                          .message_balance,
                                        _vm.quotaWarningList[0].entitlement
                                          .max_message
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("MessageQuota")) + ": "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.quotaWarningList[0].entitlement
                                              .message_balance
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                                (_vm.isRed(
                                  _vm.quotaWarningList[0].entitlement
                                    .connection_request_balance,
                                  _vm.quotaWarningList[0].entitlement
                                    .max_connection_request
                                ) ||
                                  _vm.isRed(
                                    _vm.quotaWarningList[0].entitlement
                                      .message_balance,
                                    _vm.quotaWarningList[0].entitlement
                                      .max_message
                                  ) ||
                                  _vm.isRed(
                                    _vm.quotaWarningList[0].entitlement
                                      .connection_balance,
                                    _vm.quotaWarningList[0].entitlement
                                      .max_connection
                                  )) &&
                                _vm.quotaWarningList[0].version_name !=
                                  "Prime Plan"
                                  ? [
                                      _c(
                                        "span",
                                        { staticClass: "quota-text" },
                                        [_vm._v("|")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "quota-text" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Upgradeplan")) + ":"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "quota-link",
                                          attrs: {
                                            href: "mailto:" + _vm.mailInfo,
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.mailInfo))]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm.layout !== "side" && !_vm.isMobile
            ? _c(
                "div",
                {
                  staticClass: "admin-header-menu",
                  style: `width: ${_vm.menuWidth};`,
                },
                [
                  _c("i-menu", {
                    staticClass: "head-menu",
                    class: [_vm.lang],
                    attrs: {
                      theme: _vm.headerTheme,
                      mode: "horizontal",
                      options: _vm.menuData,
                    },
                    on: { select: _vm.onSelect },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "admin-header-right-wrapper" }, [
            _c(
              "div",
              { class: ["admin-header-right", _vm.headerTheme] },
              [
                _c(
                  "a-dropdown",
                  { staticClass: "lang header-item" },
                  [
                    _c(
                      "div",
                      [
                        _c("a-icon", { attrs: { type: "global" } }),
                        _vm._v(" " + _vm._s(_vm.langAlias)),
                      ],
                      1
                    ),
                    _c(
                      "a-menu",
                      {
                        attrs: {
                          slot: "overlay",
                          "selected-keys": [
                            _vm.localLang ? _vm.localLang : _vm.lang,
                          ],
                        },
                        on: { click: (val) => _vm.setClang(val) },
                        slot: "overlay",
                      },
                      _vm._l(_vm.langList, function (lang) {
                        return _c("a-menu-item", { key: lang.key }, [
                          _vm._v(_vm._s(lang.name)),
                        ])
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("header-avatar", { staticClass: "header-item" }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "admin-header-right redeemCodeDropdown" },
              [
                _c(
                  "a-popover",
                  {
                    attrs: {
                      title: "",
                      overlayClassName: "redeemCode-popover",
                      trigger: "click",
                    },
                    model: {
                      value: _vm.visible,
                      callback: function ($$v) {
                        _vm.visible = $$v
                      },
                      expression: "visible",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      [
                        _c(
                          "div",
                          { staticClass: "popover-title", class: [_vm.lang] },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("RedeemCodeDropdownTitle")) +
                                " "
                            ),
                            _c(
                              "a-popover",
                              {
                                staticStyle: { "z-index": "98" },
                                attrs: {
                                  trigger: "click",
                                  placement: "leftTop",
                                },
                                model: {
                                  value: _vm.helpVisiable,
                                  callback: function ($$v) {
                                    _vm.helpVisiable = $$v
                                  },
                                  expression: "helpVisiable",
                                },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "popbox",
                                      style: {
                                        "text-align":
                                          _vm.lang == "AR" ? "right" : "left",
                                      },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "main-tit",
                                          class: [_vm.lang],
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("helpTitle")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ptit",
                                          class: [_vm.lang],
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("helpDes")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "main-tit",
                                          class: [_vm.lang],
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("helpTitle2")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ptit",
                                          class: [_vm.lang],
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("helpDes2")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "main-tit",
                                          class: [_vm.lang],
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("helpTitle3")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ptit",
                                          class: [_vm.lang],
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.$t("helpDes3"))),
                                          ]),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.$t("helpDes4"))),
                                          ]),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.$t("helpDes5"))),
                                          ]),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.$t("helpDes6"))),
                                          ]),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.$t("helpDes7"))),
                                          ]),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.$t("helpDes8"))),
                                          ]),
                                          _c("div", [
                                            _vm._v(_vm._s(_vm.$t("helpDes9"))),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass: "main-tit",
                                          class: [_vm.lang],
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("helpTitle3")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ptit",
                                          class: [_vm.lang],
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("helpDes10")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("a-icon", {
                                  staticStyle: {
                                    "font-size": "14px",
                                    color: "#0e756a",
                                    cursor: "pointer",
                                    "margin-left": "6px",
                                  },
                                  attrs: { type: "question-circle" },
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a-spin",
                          { attrs: { spinning: _vm.codeListLoading } },
                          [
                            _vm.codeList && _vm.codeList.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "code-con beauty-scroll",
                                    class: [_vm.lang],
                                  },
                                  _vm._l(_vm.codeList, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.order_id,
                                        staticClass: "code-item",
                                        class: {
                                          "code-disable":
                                            item.linkedin_login != 0 &&
                                            item.linkedin_email,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "num",
                                            class: [_vm.lang],
                                          },
                                          [_vm._v(_vm._s(item.code))]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "code-txt",
                                            class: [_vm.lang],
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.getCodeText(item)) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        item.linkedin_login != 0 &&
                                        item.linkedin_email
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "LinkedinAccount-txt ellipsis",
                                                class: [_vm.lang],
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("LinkedinAccount")
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      title:
                                                        item.linkedin_email,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.linkedin_email
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "link-account-btn",
                                                class: [_vm.lang],
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goLinkedinAccount(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("LinkAccountBtn")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _c(
                                  "div",
                                  { staticClass: "no-data", class: [_vm.lang] },
                                  [_vm._v(" " + _vm._s(_vm.$t("noData")) + " ")]
                                ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "footer-btn",
                            class: [_vm.lang],
                            on: { click: _vm.showSetCodeModal },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("RedeemActivationCode")) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "header-item",
                        class: [_vm.lang],
                        on: { click: _vm.showCodePopover },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("RedeemCode")) + " ")]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm.showCodeDialog
        ? _c(
            "a-modal",
            {
              attrs: {
                title: "",
                visible: _vm.showCodeDialog,
                "confirm-loading": _vm.confirmLoading,
                closable: false,
                maskClosable: false,
                okText: _vm.$t("Confirm"),
                cancelText: _vm.$t("Cancel"),
                dialogClass: "showCodeTialog-class",
              },
              on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
            },
            [
              _c("div", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm.$t("RedeemActivationCode"))),
              ]),
              _c(
                "a-form",
                {
                  staticClass: "form",
                  attrs: { form: _vm.form, layout: "horizontal" },
                },
                [
                  _c(
                    "a-form-item",
                    {
                      class: [_vm.lang],
                      staticStyle: {
                        "margin-bottom": "10px",
                        "margin-top": "16px",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "code",
                              {
                                initialValue: _vm.code,
                                trim: true,
                                rules: [
                                  {
                                    required: true,
                                    validator: function (
                                      rule,
                                      value,
                                      callback
                                    ) {
                                      if (!value || !value.trim("")) {
                                        callback(_vm.$t("modalInputError"))
                                        return
                                      }
                                      callback()
                                    },
                                  },
                                ],
                              },
                            ],
                            expression:
                              "[\n            'code',\n            {\n              initialValue: code,\n              trim: true,\n              rules: [\n                {\n                  required: true,\n                  validator: function (rule, value, callback) {\n                    if (!value || !value.trim('')) {\n                      callback($t('modalInputError'));\n                      return;\n                    }\n                    callback();\n                  },\n                },\n              ],\n            },\n          ]",
                          },
                        ],
                        staticClass: "process-input",
                        attrs: {
                          size: "large",
                          maxLength: 16,
                          placeholder: _vm.$t("modalInput"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }